"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./style/terms.css") : void 0;
var _SectionExpandable = _interopRequireDefault(require("@concur/nui-widgets/lib/Section/SectionExpandable"));
var _Checkbox = _interopRequireDefault(require("@concur/nui-widgets/lib/Forms/Checkbox"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var TermsPanel = /*#__PURE__*/function (_React$Component) {
  function TermsPanel() {
    _classCallCheck(this, TermsPanel);
    return _callSuper(this, TermsPanel, arguments);
  }
  _inherits(TermsPanel, _React$Component);
  return _createClass(TermsPanel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        showCheckbox = _this$props.showCheckbox,
        checked = _this$props.checked,
        _onChange = _this$props.onChange,
        title = _this$props.title,
        description = _this$props.description,
        checkboxId = _this$props.checkboxId,
        expandButtonId = _this$props.expandButtonId,
        contentContainerId = _this$props.contentContainerId;
      var showCheckboxStyle = {
        visibility: showCheckbox ? 'visible' : 'hidden'
      };
      var tAndCTitle = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
        className: "t-and-c-title"
      }, title), /*#__PURE__*/_react.default.createElement("p", {
        className: "t-and-c-description"
      }, /*#__PURE__*/_react.default.createElement("span", null, description)));
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "term-item-and-box checkbox"
      }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
        inputProps: {
          id: checkboxId,
          style: showCheckboxStyle
        },
        checked: checked,
        inline: true,
        onChange: function onChange(_, e) {
          return _onChange(e);
        },
        label: title,
        hiddenLabel: true
      }), /*#__PURE__*/_react.default.createElement(_SectionExpandable.default, {
        expanded: false,
        title: tAndCTitle,
        headingLevel: "h3",
        expandLabel: title,
        collapseLabel: title,
        buttonProps: {
          id: expandButtonId
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        id: contentContainerId
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "terms-panel-children"
      }, this.props.children))));
    }
  }]);
}(_react.default.Component);
TermsPanel.propTypes = {
  showCheckbox: _propTypes.default.bool,
  checked: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  children: _propTypes.default.node,
  title: _propTypes.default.string,
  description: _propTypes.default.node,
  checkboxId: _propTypes.default.string,
  expandButtonId: _propTypes.default.string,
  contentContainerId: _propTypes.default.string
};
var _default = exports.default = TermsPanel;